// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G6HOAU74QQHZZm {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.vCdtKlHECYDgUn {
  display: flex;
  justify-content: center;
}
.xGaLuny2lcuQjN {
  flex: 1 1 auto;
  min-height: calc(100vh - 40px);
  padding-bottom: 32px;
  background-color: var(--ds-surface, #ffffff);
}
.R3dCjOjYgXDlzq {
  display: flex;
  justify-content: center;
  padding-top: 32px;
}
@media only screen and (max-width: 600px) {
  .R3dCjOjYgXDlzq {
    display: block;
    padding-top: 0;
  }
}
@media only screen and (max-width: 860px) {
  .R3dCjOjYgXDlzq.SavyJcehDsfcO1 {
    display: block;
    padding-top: 0;
  }
}
.Fe1a981KIlgQS4 {
  width: 960px;
}
@media only screen and (max-width: 1242px) {
  .Fe1a981KIlgQS4 {
    width: 640px;
  }
}
@media only screen and (max-width: 1007px) {
  .Fe1a981KIlgQS4 {
    width: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .Fe1a981KIlgQS4.EqfJi2tw0VUVl2 {
    display: none;
  }
}
.Fe1a981KIlgQS4.SavyJcehDsfcO1 {
  width: 960px;
}
@media only screen and (max-width: 1520px) {
  .Fe1a981KIlgQS4.SavyJcehDsfcO1 {
    width: 640px;
  }
}
@media only screen and (max-width: 1267px) {
  .Fe1a981KIlgQS4.SavyJcehDsfcO1 {
    width: 100%;
  }
}
.Va1iwKh7bP_iWP {
  display: flex;
  align-items: center;
  justify-content: center;
}
.eAx0_09iVYLLXe {
  padding: 0 15%;
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  line-height: 24px;
}
@media only screen and (max-width: 1242px) {
  .eAx0_09iVYLLXe {
    padding: 0 10%;
  }
}
.eAx0_09iVYLLXe .jpYHGni5MRVmdV {
  width: 100%;
  margin: 16px auto;
}
.y2v8D5bNdGK7eU {
  display: flex;
}
@media only screen and (max-width: 600px) {
  .y2v8D5bNdGK7eU {
    flex-direction: column;
  }
}
@media only screen and (max-width: 860px) {
  .y2v8D5bNdGK7eU.iqA23rvPGPHnPT {
    flex-direction: column;
  }
}
.d2X6RemNc2rudF {
  display: flex;
  justify-content: space-between;
}
.d2X6RemNc2rudF a {
  text-decoration: none;
}
.V2c1K4wtTVdSra {
  margin-top: -8px;
}
.zua6sQD9MeSj6C {
  position: sticky;
  top: 16px;
  align-self: flex-start;
  width: 25%;
  min-width: 25%;
  padding: 0 32px;
}
@media only screen and (max-width: 600px) {
  .zua6sQD9MeSj6C {
    position: initial;
    top: 0;
    align-self: auto;
    width: calc(100% - 32px);
    padding: 0 16px;
  }
}
@media only screen and (max-width: 600px) {
  .zua6sQD9MeSj6C.iqA23rvPGPHnPT {
    position: initial;
    top: 0;
    align-self: auto;
    width: calc(100% - 32px);
    padding: 0 16px;
  }
}
.MqWkeHa3pu96ke {
  width: 75%;
  padding: 0 32px;
}
@media only screen and (max-width: 600px) {
  .MqWkeHa3pu96ke {
    width: calc(100% - 32px);
    padding: 0 16px;
  }
}
@media only screen and (max-width: 600px) {
  .MqWkeHa3pu96ke.iqA23rvPGPHnPT {
    width: calc(100% - 32px);
    padding: 0 16px;
  }
}
.erXnRCFbd2g6pQ {
  margin-bottom: 16px;
}
.I0Wem6vuEK0hWn img {
  width: 100%;
}
.I0Wem6vuEK0hWn h1,
.I0Wem6vuEK0hWn h2,
.I0Wem6vuEK0hWn h3,
.I0Wem6vuEK0hWn h4 {
  margin: 20px 0 20px 0;
}
.I0Wem6vuEK0hWn ul {
  margin: 20px;
  list-style: disc;
}
.pH3UfSkddg18CV {
  display: flex;
  align-items: center;
}
.xXIHrF9BdGtX19 {
  display: flex;
  justify-content: center;
}
img.xn5J93LNAWbnd_ {
  width: 100%;
  max-width: 240px;
  height: 100%;
  max-height: 240px;
}
.I5U2GdHNq9WwIC {
  margin: 16px 0;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.DUh65_vTLOOLiC {
  padding: 16px 0;
}
.DUh65_vTLOOLiC li {
  margin: 8px 0;
}
.anuckBfDgQa69x {
  display: inline-block;
  margin-right: 4px;
  margin-bottom: 4px;
  padding-top: 4px;
  padding-right: 8px;
  padding-bottom: 4px;
  padding-left: 8px;
  overflow: hidden;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  text-decoration: none;
  white-space: normal;
}
.anuckBfDgQa69x:hover {
  background-color: var(--ds-surface-hovered, #f1f2f4);
  color: var(--ds-text, #172b4d);
}
.Zy1UrfjMg18Tfj {
  margin-left: 8px;
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.Zy1UrfjMg18Tfj:hover {
  text-decoration: underline;
}
.RnxYpAQpEOIyT1 {
  width: 12px;
  min-width: 12px;
  max-width: 12px;
}
.VABId0cYo08OnX,
.TmOsSPy4N8lPNG {
  margin-left: 8px;
}
.Yv5YKGsAJPkZAi {
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
  margin-bottom: -4px;
}
.aBLk1z5XGpwhlg {
  display: flex;
  align-items: center;
  height: 24px;
  margin-right: 8px;
  margin-bottom: 4px;
  padding: 0 12px;
  border-radius: 3px;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 14px;
  white-space: nowrap;
}
.xZnQ_HEG4egzcV {
  margin-right: 8px;
}
.yFQaTtAFDULB_g {
  background-color: var(--ds-background-accent-purple-subtlest, #f3f0ff);
}
.dPyU8At6U6sJsA {
  background-color: var(--ds-background-accent-blue-subtlest, #e9f2ff);
}
.NnzO88ECNM_MSO {
  background-color: var(--ds-background-accent-purple-subtlest, #f3f0ff);
}
.Q1C36s61XNEOGZ {
  margin-top: 28px;
  padding: 16px 42px 16px 16px;
  border-radius: 3px;
  background-color: var(--ds-background-accent-purple-subtlest, #f3f0ff);
}
.Q1C36s61XNEOGZ .EdPDZp_fDTE_Nr {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 20px;
}
.Q1C36s61XNEOGZ .EdPDZp_fDTE_Nr::after {
  content: attr(data-beta-string);
  margin-left: 8px;
  padding: 2px 8px 2px 8px;
  border-radius: 15px;
  background-color: var(--ds-background-accent-blue-subtler, #cce0ff);
  color: var(--ds-background-accent-blue-bolder, #0c66e4);
  font-size: 11px;
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 16px;
  text-align: center;
  text-transform: uppercase;
}
.mqEcB9qu_6hu9J.mqEcB9qu_6hu9J {
  margin-top: 8px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `G6HOAU74QQHZZm`,
	"flexAndCenter": `vCdtKlHECYDgUn`,
	"directoryBody": `xGaLuny2lcuQjN`,
	"navigationAndContent": `R3dCjOjYgXDlzq`,
	"workspaceNavigationExpanded": `SavyJcehDsfcO1`,
	"directoryContent": `Fe1a981KIlgQS4`,
	"navigationExpanded": `EqfJi2tw0VUVl2`,
	"directorySpinnerContainer": `Va1iwKh7bP_iWP`,
	"listingWrapper": `eAx0_09iVYLLXe`,
	"upgradePromptFullPupPage": `jpYHGni5MRVmdV`,
	"listingRow": `y2v8D5bNdGK7eU`,
	"workspaceNavExpandedAndEnabled": `iqA23rvPGPHnPT`,
	"listingHeading": `d2X6RemNc2rudF`,
	"addButton": `V2c1K4wtTVdSra`,
	"listingLeftColumn": `zua6sQD9MeSj6C`,
	"listingRightColumn": `MqWkeHa3pu96ke`,
	"listingName": `erXnRCFbd2g6pQ`,
	"listingContent": `I0Wem6vuEK0hWn`,
	"iconAndText": `pH3UfSkddg18CV`,
	"iconContainer": `xXIHrF9BdGtX19`,
	"pluginIcon": `xn5J93LNAWbnd_`,
	"sideBarSection": `I5U2GdHNq9WwIC`,
	"linksSection": `DUh65_vTLOOLiC`,
	"tag": `anuckBfDgQa69x`,
	"listingLink": `Zy1UrfjMg18Tfj`,
	"complianceIcon": `RnxYpAQpEOIyT1`,
	"madeBy": `VABId0cYo08OnX`,
	"complianceText": `TmOsSPy4N8lPNG`,
	"badges": `Yv5YKGsAJPkZAi`,
	"pupBadge": `aBLk1z5XGpwhlg`,
	"usageBadgeIcon": `xZnQ_HEG4egzcV`,
	"genericBadge": `yFQaTtAFDULB_g`,
	"darkModeBadge": `dPyU8At6U6sJsA`,
	"integrationBadge": `NnzO88ECNM_MSO`,
	"integrationBox": `Q1C36s61XNEOGZ`,
	"integrationHeader": `EdPDZp_fDTE_Nr`,
	"deprecationBanner": `mqEcB9qu_6hu9J`
};
export default ___CSS_LOADER_EXPORT___;
